import type { Dispatch, ReactNode, RefObject, SetStateAction } from 'react';
import { createContext, useContext, useMemo, useRef, useState } from 'react';

import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

interface ChartContextType {
  chartRef: RefObject<any>;
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
  setChartSeries: Dispatch<SetStateAction<ExtendedSeriesOptionsType[] | undefined>>;
}

const ChartContext = createContext<ChartContextType | undefined>(undefined);

export const ChartProvider = ({ children }: { children: ReactNode }) => {
  const chartRef = useRef<any>(null);
  const [chartSeries, setChartSeries] = useState<ExtendedSeriesOptionsType[]>();

  const value = useMemo(
    () => ({
      chartRef,
      chartSeries,
      setChartSeries
    }),
    [chartSeries]
  );

  return <ChartContext.Provider value={value}>{children}</ChartContext.Provider>;
};

export const useChartContext = () => {
  const context = useContext(ChartContext);
  if (!context) throw new Error('useChartContext must be used within ChartProvider');
  return context;
};
